import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Customer } from '../../../models/customer.model';
import { Permission } from '../../../models/permission.model';
import { PrimengDropdown } from '../../../models/primeng-dropdown';
import { User } from '../../../models/user.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { fadeInOut } from '../../../services/animations';
import { CustomersMappingService } from '../../../services/customers-mapping.service';
import { CustomersService } from '../../../services/customers.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'customers-mapping',
    template: require('./customers-mapping.component.html'),
    styles: [require('./customers-mapping.component.css')],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.None
})

export class CustomersMappingComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];


    user: User = new User;
    customer: Customer = new Customer;
    users: PrimengDropdown[];
    sourceCustomersMapping: Customer[] = [];
    targetCustomersMapping: Customer[] = [];
    mode: string = "Bijwerken";

    constructor(private customersService: CustomersService, private customersMappingService: CustomersMappingService,
        private router: Router, private activatedRoute: ActivatedRoute, private alertService: AlertService, private ngxLogger: NGXLogger, private accountService: AccountService) { }

    ngOnInit(): void {
        const id = this.activatedRoute.snapshot.params["id"];
        if (id) {
            this.mode = "Bijwerken";
            this.user.Id = id;
            this.getSourceCustomersForMapping();
            this.getTargetCustomersForMapping();
        }
        this.getUsers();
    }

    getUsers() {
        const getAllUsersSubscriber = this.customersMappingService.getAllUsers().subscribe((users: User[]) => {
            this.users = [];
            if (users != null && users.length > 0) {
                users.forEach((u: User) => {
                    this.users.push({ label: `${u.FullName} - ${u.Email}`, value: u.Id });
                });
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(getAllUsersSubscriber);
    }

    changeUserDropdown(event: any) {
        if (event && event.value && this.users) {
            this.user.FullName = this.users.find(f => f.value === event.value).label;
        }
        this.getSourceCustomersForMapping();
        this.getTargetCustomersForMapping();
    }

    // getById() {
    //     this.customersService.getById(this.customer.Id).subscribe((res: Customer) => {
    //         this.customer = res;
    //     }, error => {
    //         this.ngxLogger.error(error.message);
    //         throw error;
    //     });
    // }

    getSourceCustomersForMapping() {
        const srcCustMappingSubscriber = this.customersMappingService.getSourceCustomersForMapping(this.user.Id)
            .subscribe((customersResponse: Customer[]) => {
                if (customersResponse != null && customersResponse.length > 0) {
                    this.sourceCustomersMapping = customersResponse.filter(c => c.IsActive == true);
                } else {
                    this.sourceCustomersMapping = null;
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });

        this.subscribers.push(srcCustMappingSubscriber);
    }

    getTargetCustomersForMapping() {
        const trgCustMappingSubscriber = this.customersMappingService.getTargetCustomersForMapping(this.user.Id).subscribe((res: Customer[]) => {
            this.targetCustomersMapping = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(trgCustMappingSubscriber);
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    updateCustomerMappingGroup() {
        if (this.caneditCustomersMappingPermission) {
            if (this.targetCustomersMapping.length > 0) {
                const updCustomerMappingSubscriber = this.customersMappingService.updateCustomerMappingGroup(this.user.Id, this.targetCustomersMapping).subscribe((res: Customer[]) => {
                    this.alertService.showMessage('Link gebruiker aan klant', 'Link gebruiker aan klant succesvol opgeslagen!', MessageSeverity.success);
                }, error => {
                    this.ngxLogger.error(error.message);
                    throw error;
                });
                this.subscribers.push(updCustomerMappingSubscriber);
            } else {
                this.alertService.showMessage('Link gebruiker aan klant', 'Selecteer ten minste één klant!', MessageSeverity.error);
            }
        } else {
            this.alertService.showMessage('Link gebruiker aan klant', 'U bent niet gemachtigd om records te bewerken!', MessageSeverity.warn);
        }
    }


    ngOnDestroy(): void {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }


    get canmanageCustomersMappingPermission() {
        return this.accountService.userHasPermission(Permission.manageCustomersMappingPermission);
    }

    get canviewCustomersMappingPermission() {
        return this.accountService.userHasPermission(Permission.viewCustomersMappingPermission);
    }

    get caneditCustomersMappingPermission() {
        return this.accountService.userHasPermission(Permission.editCustomersMappingPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/customers/customers-mapping/customers-mapping.component.ts